(function(algolia) {
  'use strict';
  var instantsearch = algolia.externals.instantsearch;
  var algoliasearch = algolia.externals.algoliasearch;
  var searchBox = algolia.externals.widgets.searchBox;
  var stats = algolia.externals.widgets.stats;
  var sortBy = algolia.externals.widgets.sortBy;
  var clearRefinements = algolia.externals.widgets.clearRefinements;
  var panel = algolia.externals.widgets.panel;
  var hits = algolia.externals.widgets.hits;
  var pagination = algolia.externals.widgets.pagination;
  var configure = algolia.externals.widgets.configure;
  var connectCurrentRefinements = algolia.externals.connectors.connectCurrentRefinements;
  var aa = algolia.externals.aa;

  aa.init({
    appId: algolia.config.app_id,
    apiKey: algolia.config.search_api_key,
  });

  var collectionPage =
    Boolean(algolia.is_collection_results_page) &&
    Boolean(algolia.config.instant_search_enabled_on_collection);

  if ((!algolia.full_results && !collectionPage) || !algolia.config.instant_search_enabled) {
    return;
  }

  /**
   * Array which will contain all filters to be applied while initiating the
   * search API call.
   */
  var searchFilters = [];

  var collectionFacetFilter = null;
  var collectionRulesContextValue = null;
  if (collectionPage) {
    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
    var handle = Boolean(matches) && matches.length === 2 ? matches['input'].split('/collections/')[1].split('/') : null;

    if (handle.length === 1) {
      collectionFacetFilter = `collections:"${handle[0]}"`;
    } else {
      collectionFacetFilter = `collections:"${handle[0]}" AND tags:"${handle[1]}"`;
    }

    // Add the collection filter to the list of search filters
    searchFilters.push(collectionFacetFilter);

    collectionRulesContextValue = algolia.config.collection_id_query_rules
      ? algolia.current_collection_id
      : handle;
  }

  // Filters for stock policy
  var stockPolicyFilter = null;
  if (algolia.config.stock_policy) {
    if (algolia.config.stock_policy === 'allow') {
      /**
       * For 'allow', we don't need to add any filter as we want to continue
       * displaying all out of stock items.
       */
    } else if (algolia.config.stock_policy === 'deny') {
      // For 'deny' we will filter out all items based on inventory quantity
      stockPolicyFilter = 'inventory_quantity > 0';
    } else if (algolia.config.stock_policy === 'continue') {
      /**
       * For 'continue' we will filter on `inventory_available` attribute whose
       * value is dependent on:
       * `inventory_quantity > 0 OR inventory_policy == 'continue'`
       */
      stockPolicyFilter = 'inventory_available:true';
    }

    // Add the stock policy filter to the list of search filters
    if (stockPolicyFilter) {
      searchFilters.push(stockPolicyFilter);
    }
  }

  var results_selector = collectionPage
    ? algolia.config.collection_css_selector
    : algolia.config.results_selector;

  var activeSortOrders = collectionPage && algolia.collectionSortOrders
    ? algolia.collectionSortOrders
    : algolia.sortOrders;

  results_selector += ', .algolia-shopify-instantsearch';

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function(k) {
      if (k === 'configure' || k === 'query' || k === 'q') {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  function singleIndex(indexName) {
    return {
      stateToRoute: function(uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.q = uiState[indexName].query;
        return route;
      },
      routeToState: function(routeState) {
        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.q;
        return state;
      },
    };
  }

  var instant = {
    colors: algolia.config.colors,
    distinct: Boolean(algolia.config.show_products),
    facets: {
      hidden:
        collectionPage && algolia.collectionHiddenFacets
          ? algolia.collectionHiddenFacets
          : algolia.hiddenFacets,
      shown:
        collectionPage && algolia.collectionShownFacets
          ? algolia.collectionShownFacets
          : algolia.shownFacets,
      list:
        collectionPage && algolia.collectionFacets
          ? algolia.collectionFacets
          : algolia.facets,
      widgets:
        collectionPage && algolia.collectionFacetsWidgets
          ? algolia.collectionFacetsWidgets
          : algolia.facetsWidgets,
    },
    hitsPerPage:
      collectionPage && algolia.config.collections_full_results_hits_per_page
        ? algolia.config.collections_full_results_hits_per_page
        : algolia.config.products_full_results_hits_per_page,
    poweredBy: algolia.config.powered_by,
    search: instantsearch({
      searchClient: algoliasearch(
        algolia.config.app_id,
        algolia.config.search_api_key
      ),
      indexName: algolia.config.index_prefix + 'products',
      routing: {
        stateMapping: singleIndex(algolia.config.index_prefix + 'products'),
      },
      searchFunction: function(searchFunctionHelper) {
        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage();
        searchFunctionHelper.setQueryParameter(
          'highlightPreTag',
          '<span class="ais-highlight">'
        );
        searchFunctionHelper.setQueryParameter('highlightPostTag', '</span>');
        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter('distinct', true);
        }

        // Assign any required filters
        if (searchFilters.length) {
          searchFunctionHelper.setQueryParameter(
            'filters',
            searchFilters.join(' AND ')
          );
        }

        // Assign any required `ruleContexts` which are required for query rules
        // targeting collection pages
        if (collectionPage) {
          // Collection page merchandising:
          // If we are on a collection page, `collectionRulesContextValue` is defined
          if (collectionRulesContextValue) {
            searchFunctionHelper.setQueryParameter('ruleContexts', [
              collectionRulesContextValue.toString(),
            ]);
          } else {
            searchFunctionHelper.setQueryParameter('ruleContexts', []);
          }
        }

        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
      },
    }),
    selector: results_selector + ', .algolia-shopify-instantsearch',
    sortOrders: activeSortOrders,
    storeName: algolia.storeName,
    templates: {
      currentItem: algolia.getTemplate(
        'instant_search_current_refined_values_item'
      ),
      empty: algolia.getTemplate('instant_search_no_result'),
      page: algolia.compileTemplate('instant_search'),
      product: algolia.getTemplate('instant_search_product'),
      stats: algolia.getTemplate('instant_search_stats'),
      style: algolia.compileTemplate('instant_search.css'),
    },
  };

  algolia.instantsearch = instant;

  function readjust() {
    var width = instant.$results.offsetWidth;

    var suffix = 'lg';
    if (width < 400) suffix = 'xs';
    else if (width < 800) suffix = 'sm';
    else if (width < 1200) suffix = 'md';

    instant.$results.classList.remove('ais-results-size-xs');
    instant.$results.classList.remove('ais-results-size-sm');
    instant.$results.classList.remove('ais-results-size-md');
    instant.$results.classList.remove('ais-results-size-lg');
    instant.$results.classList.add('ais-results-size-' + suffix);
  }

  // Bind helpers
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  Object.keys(helpers).forEach(function(name) {
    var helper = helpers[name];
    instant.search.templatesConfig.helpers[name] = helper;
  });
  instant.search.templatesConfig.compileOptions = algolia.hoganOptions;

  algolia.appendStyle(
    algolia.render(instant.templates.style, {
      distinct: instant.distinct,
      colors: instant.colors,
    })
  );

  if (
    collectionPage &&
    document.querySelectorAll(algolia.config.collection_css_selector).length ===
      0
  ) {
    throw new Error(
      'Instant search CSS selector for collection page is incorrect\nFore more info see : https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector'
    );
  } else if (
    document.querySelectorAll(algolia.config.results_selector).length === 0
  ) {
    throw new Error(
      'Instant search CSS selector is incorrect\nFore more info see : https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector'
    );
  }

  instant.$results = document.querySelector(instant.selector);

  instant.$results.innerHTML = algolia.render(instant.templates.page, {
    facets: instant.facets.list,
    storeName: instant.storeName,
    translations: algolia.translations,
    multipleSortOrders: activeSortOrders.length > 1,
  });

  readjust();

  window.addEventListener('resize', function() {
    readjust();
  });

  // Mobile facets display
  instant.search.addWidgets([
    {
      init: function() {
        var $button = document.querySelector('.ais-mobile-filters .filters');
        var $facets = document.querySelector('.ais-facets');
        var $body = document.querySelector('body');
        var $wrapper = $('.wrapper');
        $wrapper.prepend('<div class="facets-overlay"></div>');
        $button.addEventListener('click', function() {
          if (!$facets.classList.contains('ais-facets__shown')) {
            $facets.classList.add('ais-facets__shown');
            $wrapper.addClass('active');
            $body.style.overflow = 'hidden';
          }
        })

        $(document).on('click', '.zk-facets-button-close', function () {
          $wrapper.removeClass('active');
          $facets.classList.remove('ais-facets__shown');
          $body.style.overflow = 'auto';
          var filtersSelected = document.querySelectorAll('.ais-current-refined-values--item')
          $('.filters-count').empty()
          if (filtersSelected.length >= 1) {
            $('.filters-count').append(`&nbsp;(${filtersSelected.length})`)
          }
        });
      },
    },
  ]);

  var configureSettings = {
    hitsPerPage: instant.hitsPerPage,
    clickAnalytics: true,
    enablePersonalization: true,
  }

  if (zookalCustomer && zookalCustomer.id) {
    configureSettings.userToken = zookalCustomer.id
  }

  instant.search.addWidgets([
    configure(configureSettings),
  ]);

  // Search input
  instant.search.addWidgets([
    searchBox({
      container: '.ais-search-box-container',
      placeholder: algolia.translations.searchForProduct,
      showReset: true,
      showSubmit: true,
      autofocus: true,
      queryHook(query, search) {
        if (!window.location.pathname.includes('search')) {
          window.location.replace(`/search?q=${query}`)
        } else {
          search(query)
        }
      },
    }),
  ]);

  // Logo & clear
  instant.search.addWidgets([
    {
      init: function(opts) {
        document
          .querySelector('.ais-clear-input-icon')
          .addEventListener('click', function() {
            opts.helper.setQuery('').search();
            var input = document.querySelector('.ais-search-box--input');
            input.value = '';
            input.focus();
          });
      },
      render: function(opts) {
        if (!opts.state.query) {
          if (instant.poweredBy) {
            document.querySelector('.ais-algolia-icon').style.display = '';
          }
          document.querySelector('.ais-clear-input-icon').style.display =
            'none';
        } else {
          document.querySelector('.ais-clear-input-icon').style.display = '';
        }
      },
    },
  ]);

  // Stats
  instant.search.addWidgets([
    stats({
      container: '.ais-stats-container',
      templates: {
        text: instant.templates.stats,
      },
    }),
  ]);

  // Sort orders
  if (activeSortOrders.length > 1) {
    instant.search.addWidgets([
      sortBy({
        container: '.ais-sort-orders-container',
        items: instant.sortOrders,
      }),
    ]);
  }

  if (activeSortOrders.length > 1) {
    instant.search.addWidgets([
      sortBy({
        container: '.ais-sort-orders-container-mobile',
        items: instant.sortOrders
      }),
    ]);
  }

  // Hidden facets
  var list = instant.facets.hidden.map(function(facet) {
    return facet.name;
  });
  instant.search.addWidgets([
    {
      getConfiguration: function() {
        return {
          facets: list,
          disjunctiveFacets: list,
        };
      },
      init: function() {},
    },
  ]);

  // Create the render function
  var createDataAttribtues = function(refinement) {
    return Object.keys(refinement)
      .map(function(key) {
        return 'data-' + key + '="' + encodeURIComponent(refinement[key] || '') + '"';
      })
      .join(' ');
  };

  var renderListItem = function(item) {
    return item.refinements
      .map(function(refinement) {
        return (
          `<li class="ais-current-refined-values--item">
            <div ${createDataAttribtues(refinement)} class="ais-current-refined-values--label">
              ${refinement.label}
              <img src="//cdn.shopify.com/s/files/1/0278/5234/1317/t/2/assets/remove-filter-icon.svg?v=15671992959517046831641789260" alt="remove item"/>
            </div>
          </li>`
        );
      })
      .join('');
  };

  var renderCurrentRefinements = function(renderOptions) {
    var items = renderOptions.items;
    var refine = renderOptions.refine;
    var widgetParams = renderOptions.widgetParams;

    widgetParams.container.innerHTML =
      `<div class="ais-current-refined-values--header ais-header">Filters selected</div>
        <div class="ais-root ais-current-refined-values ais-facet">
          <ul class="ais-current-refined-values--list">
            ${items.map(renderListItem).join('')}
          </ul>
      </div>`

    Array.prototype.slice
      .call(
        widgetParams.container.querySelectorAll(
          '.ais-current-refined-values--label'
        )
      )
      .forEach(function(element) {
        element.addEventListener('click', function(event) {
          var item = Object.keys(event.currentTarget.dataset).reduce(function(
            acc,
            key
          ) {
            var itemData = {};
            itemData[key] = decodeURIComponent(event.currentTarget.dataset[key]);
            return algolia.assign({}, acc, itemData);
          },
          {});

          refine(item);
        });
      });
  };

  // Create the custom widget
  var customCurrentRefinements = connectCurrentRefinements(
    renderCurrentRefinements
  );

  var hasRefinements = function(helper, facetsList) {
    return facetsList.some(function(f) {
      var isConjunctiveFacetRefined =
        helper.state.isConjunctiveFacet(f.name) &&
        helper.state.isFacetRefined(f.name);
      var isDisjunctiveFacetRefined =
        helper.state.isDisjunctiveFacet(f.name) &&
        helper.state.isDisjunctiveFacetRefined(f.name);
      var isHierarchicalFacetRefined =
        helper.state.isHierarchicalFacet(f.name) &&
        helper.state.isHierarchicalFacetRefined(f.name);

      var numericRefinements = helper.state.getNumericRefinements(f.name);
      var isNumericFacetRefined = Object.keys(numericRefinements).some(function(
        operator
      ) {
        return numericRefinements[operator].length > 0;
      });

      return (
        isNumericFacetRefined ||
        isConjunctiveFacetRefined ||
        isDisjunctiveFacetRefined ||
        isHierarchicalFacetRefined
      );
    });
  };

  var customCurrentRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(customCurrentRefinements);

  var clearRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(clearRefinements);

  instant.search.addWidgets([
    clearRefinementsWithPanel({
      container: document.querySelector('.ais-clear-refinements-container'),
      templates: {
        resetLabel: algolia.translations.clearAll,
      },
    }),
    customCurrentRefinementsWithPanel({
      container: document.querySelector(
        '.ais-current-refined-values-container'
      ),
    }),
  ]);

  // Facets
  instant.facets.widgets.forEach(function(widget) {
    instant.search.addWidgets([widget.widget(widget.params)]);
  });

  // Hits
  instant.search.addWidgets([
    hits({
      container: '.ais-hits-container',
      templates: {
        empty: instant.templates.empty,
        item: instant.templates.product,
      },
      transformItems: function(products) {
        const productsMapped = algolia.helpers.groupVariantProducts(products)

        if (productsMapped.length === 0) {
          $('.ais-search-header').hide()
          $('.ais-block').addClass('w-100')
        } else {
          var search_page_breadcrumb_text = $('#search-page-breadcrumb-text')
          if (search_page_breadcrumb_text) {
            search_page_breadcrumb_text.removeClass('d-none')
          }
          $('.ais-search-header').show()
          $('.ais-block').removeClass('w-100')
        }
        return productsMapped.map(function(product) {
          return algolia.assign({}, product, {
            _distinct: instant.distinct,
            can_order:
              product.inventory_management !== 'shopify' ||
              product.inventory_policy === 'continue' ||
              product.inventory_quantity > 0,
            translations: algolia.translations,
            queryID: product.__queryID,
            productPosition: product.__position,
            index: instant.search.mainIndex.getIndexName(),
          });
        });
      },
    }),
  ]);

  // Redirect to product on click
   instant.search.addWidgets([
    {
      init: function() {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var hit;
          if (el.matches('.ais-hit--cart-button')) {
            e.preventDefault()
            return
          }
          do {
            if (el.matches('.ais-hit')) {
              hit = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!hit) {
            return;
          }
          var $this = hit;
          var productHandle = $this.dataset.handle;
          var variant_id = $this.dataset.variantId;
          var distinct = $this.dataset.distinct;

          var link = '/products/' + productHandle;
          if (distinct !== 'true') {
            link += '?variant=' + variant_id;
          }
          if (algolia.config.analytics_enabled) {
            var eventName = 'Product Clicked'
            if (current_page == 'search') {
              eventName = 'Search Result Clicked'
            }
            var clickData = {
              index: algolia.config.index_prefix + 'products',
              eventName: eventName,
              queryID: hit.dataset.algoliaQueryid,
              objectIDs: [hit.dataset.algoliaObjectid],
              positions: [Number(hit.dataset.algoliaPosition)],
            };

            if (zookalCustomer && zookalCustomer.id) {
              clickData.userToken = zookalCustomer.id
            }

            // Send the click event
            if (current_page == 'search') {
              aa.clickedObjectIDsAfterSearch(clickData);
            } else {
              aa.clickedObjectIDs(clickData);
            }
            /**
             * Uncomment the following function call to start storing data in
             * local storage for conversion tracking
             */
            algolia.saveForConversionTracking(clickData);
          }
          window.location.href = link;
        });
      },
    },
  ]);

  // Add to cart
  instant.search.addWidgets([
    {
      init: function() {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          e.stopPropagation();
          if (e.target.dataset.formId) {
            let id = e.target.dataset.formId.split('-').pop();
            Shopify.addItem(parseInt(id), 1);
          }
        });
      },
    },
  ]);

  // No result actions
  instant.search.addWidgets([
    {
      init: function(opts) {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearFilters;
          do {
            if (el.matches('.ais-hit-empty--clear-filters')) {
              clearFilters = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearFilters) {
            return;
          }

          var helper = opts.helper;
          helper.clearTags();
          instant.facets.list.forEach(function(facet) {
            helper.clearRefinements(facet.name);
          });
          helper.search();
        });

        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearInput;
          do {
            if (el.matches('.ais-hit-empty--clear-input')) {
              clearInput = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearInput) {
            return;
          }

          opts.helper.setQuery('').search();
          var input = document.querySelector('.ais-search-box--input');
          input.value = '';
          input.focus();
        });
      },
    },
  ]);

  // hide pagination when has just one page
  var paginationTop = panel({
    hidden: ({ results }) => results.nbPages <= 1,
  })(pagination);
  var paginationBottom = panel({
    hidden: ({ results }) => results.nbPages <= 1,
  })(pagination);

  // Pagination Bottom
  instant.search.addWidgets([
    paginationBottom({
      container: '.ais-pagination-container-bottom',
      padding: 2,
      maxPages: 20,
      showFirst: false,
      showLast: false,
      templates: {
        previous: 'Previous',
        next: 'Next'
      }
    }),
  ]);

  // HANDLERS ON FIRST LOAD OR REFRESH
  instant.search.on('render', function () {

    // add Zookal Study Banner at 3º position
    const zookalStudyBannerLink = $('.ais-Hits-item .zookal-study-banner-link')
    if (zookalStudyBannerLink.length) {
      zookalStudyBannerLink.parent()[0].remove()
    }

    const zookalStudyBanner = $('.ais-Hits-item .zookal-study-banner')
    if (zookalStudyBanner.length) {
      zookalStudyBanner.parent()[0].remove()
    }

    let htmlToRender
    if (is_user_subscribed) {
      htmlToRender = `
        <li class="ais-Hits-item">
          <div class="zookal-study-banner">
            <h5 class="title">Welcome, ${user_name}</h5>
            <p class="subtitle">Please continue to enjoy 10% off Textbooks plus free shipping</p>
          </div>
        </li>
      `
    } else {

      const subscribeSaveUrl = window.location.hostname === 'textbooks.zookal.co.nz'
        ? 'https://textbooks.zookal.co.nz/pages/subscribe-and-save'
        : 'https://textbooks.zookal.com.au/pages/subscribe-and-save'

      htmlToRender = `
        <li class="ais-Hits-item zookal-study-banner-item">
          <a class="zookal-study-banner-link" id="zookal-study-promo-banner" href="${subscribeSaveUrl}" target="_blank">
            <div class="zookal-study-banner">
              <h5 class="title">Zookal Study</h5>
              <p class="subtitle">Save an extra 10% off Textbooks and free shipping</p>
              <p class="description">Try Zookal Study Premium, FREE for the 1st month. Cancel anytime.</p>
              <p class="learn-more">Learn more</p>
            </div>
          </a>
        </li>
      `
    }
    var secondElementCollectionPage = $('.ais-Hits-list .ais-Hits-item')[1]
    $(secondElementCollectionPage).after(htmlToRender)

    // hide empty facets group
    var facetSelector = '.ais-RefinementList';
    var facets = document.querySelectorAll(facetSelector);
    facets.forEach(function (element) {
      if (element.className.includes('ais-RefinementList--noRefinement')) {
        element.parentNode.parentNode.style.display = 'none';
      } else {
        element.parentNode.parentNode.style.display = 'block';
      }
    });

    // Add quantity of selected filters
    var filtersSelected = document.querySelectorAll('.ais-current-refined-values--item')
    $('.filters-count').empty()
    if (filtersSelected.length >= 1) {
      $('.filters-count').append(`&nbsp;(${filtersSelected.length})`)
    }

    var collection_search_page_filters = document.querySelectorAll('.ais-RefinementList-item')
    if (collection_search_page_filters) {
      collection_search_page_filters.forEach(function(element) {
        if (element) {
          element.addEventListener('click', function(e) {
            if (e && e.target && e.target.textContent && !element.className.includes('ais-RefinementList-item--selected')) {
              var clickFilter = {
                index: algolia.config.index_prefix + 'products',
                eventName: 'Filter Clicked',
                filters: [ 'category:' + algolia.helpers.slugify(e.target.textContent.split('  ')[0]) ]
              }

              if (zookalCustomer && zookalCustomer.id) {
                clickFilter.userToken = zookalCustomer.id
              }

              aa.clickedFilters(clickFilter);
            }
          })
        }
      })
    }
  });

  // Main
  instant.search.start();

  algolia.contentHide.parentNode.removeChild(algolia.contentHide);
})(window.algoliaShopify);
